/**
 * SessionExpiredDialog — "You've been signed out", shown over a greyed-out page
 * once the API has turned a request away for a lapsed login (see
 * `src/utils/sessionExpiry.js`). Deliberately has no close button: closing it
 * would leave the person looking at empty data that looks real.
 *
 * Props:
 *   onSignIn — starts the sign-in redirect
 */
export default function SessionExpiredDialog({ onSignIn }) {
  return (
    <div role="dialog" aria-modal="true" aria-labelledby="session-expired-title"
      style={{
        position: 'fixed', inset: 0, zIndex: 10000, display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: 'rgba(245, 246, 248, 0.82)', backdropFilter: 'grayscale(1)', WebkitBackdropFilter: 'grayscale(1)',
      }}>
      <div style={{ background: 'white', border: '1px solid #dfe3e8', borderRadius: '10px', padding: '22px 24px', width: 'min(380px, calc(100vw - 32px))', boxShadow: '0 8px 24px rgba(0,0,0,0.12)', fontFamily: 'inherit' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
          <span aria-hidden="true" style={{ fontSize: '18px' }}>🔒</span>
          <h2 id="session-expired-title" style={{ margin: 0, fontSize: '17px', fontWeight: 600, color: '#2c3e50' }}>You've been signed out</h2>
        </div>
        <p style={{ margin: '0 0 18px', fontSize: '13.5px', lineHeight: 1.5, color: '#5f6b76' }}>
          Your session expired, so this page can't load your data. Sign in again to pick up right where you left off.
        </p>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <button autoFocus onClick={onSignIn}
            style={{ padding: '8px 18px', background: '#2c3e50', color: 'white', border: 'none', borderRadius: '6px', fontSize: '13.5px', cursor: 'pointer' }}>
            Sign in again
          </button>
        </div>
      </div>
    </div>
  );
}
